<template>
  <div>
    <ProcessGroup :selectedItems="selected_requests" type="need_to_be_returned_new" />
    <div v-if="!this.$store.state.loadingData" style="margin-top: 40px">
      <div v-if="$store.state.views === 'cards'">
        <div v-if="this.$store.state.allRequests.length > 0">
          <RequestsCard
            :CardData="this.$store.state.allRequests"
            @pageCount="handlePageNumber"
            @back="handleBack"
          />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
        <div v-else>
          <div>
            <button
              @click="handleBack"
              style="
                width: 70px;
                height: 40px;
                border-radius: 5px;
                margin: 50px;
                color: white;
                background-color: #441545;
                direction: ltr;
              "
            >
              رجوع
            </button>
          </div>
          <div class="noData">لا يوجد بيانات</div>
        </div>
      </div>
      <div v-else-if="$store.state.views === 'table'" class="table__view">
        <table-component
          :showSelect="false"
          itemKey="id"
          :selectedRows.sync="selected_requests"
          :headers="headers"
          :pagination="this.$store.state.pagination"
          :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData"
          :loading="loading"
          @refresh="getTableData"
          v-model="page"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#3f0e40" small depressed dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <FreezingSingleProcess :item="item.id" />
              </v-list>
            </v-menu>
          </template>

          <template slot="item.quality_notes" slot-scope="props">
            <span v-if="!props.item.quality_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.quality_notes.length > 35
                    ? props.item.quality_notes.substring(0, 35) + "..."
                    : props.item.quality_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
            </v-tooltip>
          </template>

          <template slot="item.agent_class_note" slot-scope="props">
            <classification-cell
              :label="props.item.class_id_agent_text"
              :color="props.item.class_id_agent_color"
              :name="props.item.agent_name"
              :note="props.item.agent_notes"
              :date="props.item.comment_date"
            />
          </template>
          <template slot="item.cs_class_note" slot-scope="props">
            <classification-cell
              :label="props.item.class_id_cs_text"
              :color="props.item.class_id_cs_color"
              :name="props.item.customer_service_name"
              :note="props.item.cs_note"
              :date="props.item.customer_service_note_date"
            />
          </template>
        </table-component>
        <OrderRequestSection
          v-if="this.$store.state.openOrderRequestSection"
          style="margin-top: 50px"
        />
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      "
      v-else
    >
      <LoadingMore />
    </div>
    <NewQualitySearch type="need_to_be_returned_done" />
    <RefuseRequest />
    <QualityDialog :selectedItems="selected_requests" />
    <AdminDialog
      @selectedValue="selectedValue"
      :items="this.$store.state.allStatusAgent"
      label="استشاري المبيعات"
    />
    <OrderRequestDialog />
    <CallsDialog />
  </div>
</template>

<script>
import Axios from "axios";
import RequestsCard from "@/components/Charts/RequestsCard.vue";
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import { formatDate } from "@/mixins/formatDate";
import AdminDialog from "@/components/AdminComponent/AdminDialog.vue";
import ProcessGroup from "@/views/admin/Requests/MoveToNew/ProcessGroup.vue";
import QualityDialog from "@/components/AdminComponent/QualityDialog.vue";
import RefuseRequest from "@/views/admin/Requests/QualityNew/RefuseRequest.vue";
import NewQualitySearch from "@/views/admin/Requests/QualityNew/NewQualitySearch.vue";
import FreezingSingleProcess from "./Freezing/FreezingSingleProcess.vue";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import ClassificationCell from "@/components/Base/ClassificationCell.vue";

export default {
  name: "AdminSupport",
  components: {
    NewQualitySearch,
    OrderRequestSection,
    OrderRequestDialog,
    FreezingSingleProcess,
    RefuseRequest,
    QualityDialog,
    ProcessGroup,
    AdminDialog,
    RequestsCard,
    LoadingMore,
    CallsDialog,
    ClassificationCell,
  },

  data() {
    return {
      page: 1,
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      selected_requests: [],
      allGetData: [],
      allRequests: [],
      headers: [
        { text: "تاريخ الطلب", value: "تاريخ الطلب", width: "120px", align: "center" },
        { text: "حاله الطلب", value: "حاله الطلب", width: "120px", align: "center" },
        { text: "الجوده", value: "الجوده", width: "120px", align: "center" },
        { text: "عميل", value: "عميل", width: "120px", align: "center" },
        { text: "الجوال", value: "الجوال", align: "center" },
        {
          text: "الأستشاري",
          value: "agent_class_note",
          width: "180px",
          align: "center",
          sortable: false,
        },
        {
          text: "خدمة العملاء",
          value: "cs_class_note",
          width: "180px",
          align: "center",
          sortable: false,
        },
        {
          text: "ملاحظة استشاري الجودة",
          value: "quality_notes",
          width: "150px",
          align: "center",
        },
        { text: "سبب الرفض", value: "سبب الرفض", width: "150px", align: "center" },
        { text: "", value: "action", align: "center" },
      ],
    };
  },

  beforeDestroy() {
    this.$store.state.openOrderRequestSection = false;
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  methods: {
    handleBack() {
      this.$store.state.allRequests = [];
      this.$store.state.tableData = [];
      this.$store.state.loadingData = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getAllRequests(1, "back");
    },

    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getAllRequests(val);
      } else {
        this.searchRequest(val);
      }
    },
    searchRequest(page, type) {
      // this.$store.state.tableData = []
      this.loading = true;

      if (page > 1 || type === "table") {
        this.$store.state.bodySearch.delete("page");
        this.$store.state.bodySearch.append("page", page);

        let url = `${this.$store.state.url}/v2/employee/Requests/search?type=need_to_be_returned_done`;
        Axios.post(url, this.$store.state.bodySearch, {
          headers: this.request_headers(),
        }).then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          let response = res.data.payload.data;
          response.map((item) => {
            if (item.length === 0) {
              this.loading = false;
            }
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.allRequests.push(...response);
          this.loading = false;
        });
      }
    },

    selectedValue(itemSelected) {
      this.getAgentRequest(itemSelected);
    },

    getAgentRequest(itemSelected) {
      let body = new FormData();

      body.append("request_ids[0]", this.$store.state.selectId);
      body.append("agents_ids[0]", itemSelected.id);

      Axios.post(
        `${this.$store.state.url}/v2/employee/Requests/moveNeedToBeTurnedQualityReqNew?type=need_to_be_returned_done`,
        body,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.showPopup("success", res.data.message);
        })
        .catch((err) => {
          let error = { err };
          let message = error.err.response.data.message[0];
          this.showPopup("error", message);
        });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=need_to_be_returned_done&page=${count}&per_page=${this.$store.state.counterOfShow}`,
        { headers: this.request_headers() }
      ).then((res) => {
        res.data.payload.data.map((item) => {
          this.setTbData(item);
        });
        this.loading = false;
      });
    },

    setTbData(items) {
      this.$store.state.tableData.push({
        id: items.id,
        "تاريخ الطلب": formatDate(items.quality_request.request.created_at),
        "حاله الطلب": items.status,
        الجوده: items.qualityUser.name,
        "استشاري المبيعات": items.quality_request.request.user?.name,
        عميل: items.quality_request.request.customer.name,
        الجوال: items.quality_request.request.customer.mobile,
        class_id_agent_text:
          items.quality_request.request.class_id_agent_text ?? null,
        class_id_agent_color:
          items.quality_request.request.class_id_agent_color ?? null,
        agent_name:
          items.quality_request.request.agent_name ??
          items.quality_request.request.user?.name ??
          null,
        agent_notes:
          items.quality_request.request.agent_notes ??
          items.quality_request.request.agent_note ??
          items.quality_request.request.comment ??
          null,
        comment_date: items.quality_request.request.comment_date ?? null,
        class_id_cs_text:
          items.quality_request.request.class_id_cs_text ?? null,
        class_id_cs_color:
          items.quality_request.request.class_id_cs_color ?? null,
        customer_service_name:
          items.quality_request.request.customer_service_name ??
          items.quality_request.request.customer_service?.name ??
          null,
        cs_note:
          items.quality_request.request.cs_note ??
          items.quality_request.request.customer_service_note ??
          null,
        customer_service_note_date: items.quality_request.request
          .customer_service_note_date
          ? formatDate(
              items.quality_request.request.customer_service_note_date
            )
          : (items.quality_request.request.customer_service_note_date ?? null),
        quality_notes: items.quality_request.request.agent_notes,
        "سبب الرفض": items.reject_reason,
      });
    },

    returnValue(item) {
      if (item === 0 || !item || item === "no") {
        return "لا";
      } else {
        return "نعم";
      }
    },

    getAllRequests(count) {
      if (count === 1) {
        const myTimeout = setTimeout(() => {
          this.$store.state.allRequests = [];
        }, 2000);
      }

      if (
        this.$store.state.allRequests.length === 0 &&
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.loadingData = true;
      }
      this.loadMoreData = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=need_to_be_returned_done&page=${count}&per_page=${this.$store.state.counterOfShow}`,
        { headers: this.request_headers() }
      )
        .then((res) => {
          let response = res.data.payload.data;
          response.map((item) => {
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_need_to_be_returned_done,
          };

          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          this.loadingData = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.loadingData = false;
        });
    },

    removeDublicate(array) {
      let uniqueArray = array.filter((item, index) => {
        return (
          index ===
          array.findIndex((obj) => {
            return obj.id === item.id; // Compare based on the 'id' property
          })
        );
      });
      this.$store.state.allRequests = uniqueArray;

      this.$store.state.loadingData = false;
    },
  },

  created() {
    this.$store.state.allRequests = [];
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.bodySearch = new FormData();
    this.$store.state.isSearch = false;
    this.getAllRequests(1);
    this.$store.state.startElement = [];
    this.$store.state.views = "cards";
  },
};
</script>

<style>
.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}
</style>
